import script from "./DeferredIncomeTax.vue?vue&type=script&setup=true&lang=js"
export * from "./DeferredIncomeTax.vue?vue&type=script&setup=true&lang=js"

import "./DeferredIncomeTax.vue?vue&type=style&index=0&id=3f30590b&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3f30590b"]])

export default __exports__